import {
	SET_FORM_STATE,
	GET_TEMPLATES,
} from '../actions/TechAddActions.js';

const initialState = {
	operators: [],
	openAddOperatorDialog: false,
	detailsOperatorId: null,
	operator: {},
	formState: {
		techAdd: {
			isValid: false,
			values: {},
			touched: {},
			errors: {},
		},
		cellInfo: {
			isValid: false,
			values: {},
			touched: {},
			errors: {},
		}
	},
	openAddProjectDialog: false,
	templates: [],
};

const techAddReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					case GET_TEMPLATES: {
						return {
							...state,
							templates: action.templates
						};
					}
					default: {
						return state;
					}
	}
};

export default techAddReducer;
